import React from 'react';
import { MathJax } from 'better-react-mathjax';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownWithMath = ({ children }) => (
  <MathJax dynamic>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
  </MathJax>
);

export const renderClarifyBlocks = (blocks) => {
  return blocks.map((block, idx) => {
    if (block.type === 'text') {
      return (
        <div key={idx} className="mb-2 text-base text-gray-800">
          <MarkdownWithMath>{block.value}</MarkdownWithMath>
        </div>
      );
    } else if (block.type === 'latex') {
      return (
        
        <div key={idx} className="my-3 text-indigo-700 font-medium">
          <MathJax dynamic>{block.value}</MathJax>
        </div>
      );

    } else if (block.type === 'code') {
      return  (
          <pre
            key={idx}
            className="text-sm p-3 rounded overflow-auto mt-2"
          >
            <code>{block.value}</code>
          </pre>
      );




    } else if (block.type === 'image' && block.value) {
      const width = block.width || 'auto';
      const maxWidth = block.maxWidth || '300px';
      return (
        <div key={idx} className="mt-4">
          <img
            src={block.value}
            alt="Clarification visual"
            style={{ width, maxWidth }}
            className="mb-3 flex flex-wrap justify-start gap-3"
            onError={(e) => (e.target.style.display = 'none')}
          />
        </div>
      );

      // Inside renderBlocks function
    } else if   (block.type === 'table' && block.value?.headers && block.value?.rows) {
        return (
                <div key={idx} className="my-3 overflow-x-auto">
                  <table className="text-sm border border-collapse border-gray-300 rounded table-auto max-w-full">
                    <thead className="bg-indigo-100 text-indigo-700 font-semibold">
                      <tr>
                        {block.value.headers.map((header, hIdx) => (
                          <th key={hIdx} className="px-3 py-2 border border-gray-300 text-left whitespace-nowrap">
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {block.value.rows.map((row, rIdx) => (
                        <tr key={rIdx} className="even:bg-gray-50">
                          {row.map((cell, cIdx) => (
                            <td key={cIdx} className="px-3 py-2 border border-gray-300 whitespace-nowrap">
                              {cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
        );
      









    } else if (block.type === 'link' && block.value) {
      return (
        <div key={idx} className="my-2">
          <a
            href={block.value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            {block.label || block.value}
          </a>
        </div>
      );
    } else {
      return null;
    }
  });
};
